import RadioOrSelect from './RadioOrSelect.component';

export default RadioOrSelect;
